import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
    >
      {/* Cover Image */}
      <div className="relative overflow-hidden" style={{ aspectRatio: '3/4' }}>
        <img
          src={comic.cover}
          alt={`${comic.title} 韩国漫画`}
          title={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {/* Status Badge */}
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-white'
              : 'bg-secondary-500 text-white'
          }`}>
            {comic.status}
          </span>
        </div>
        {/* Hot Badge */}
        {comic.isHot && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-white">
              HOT
            </span>
          </div>
        )}
        {/* Rating */}
        <div className="absolute bottom-2 left-2 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-accent-400 text-xs"></i>
          <span className="text-white text-xs font-medium">{comic.rating}</span>
        </div>
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-400">
            <i className="ri-eye-line mr-1"></i>
            {(comic.views / 10000).toFixed(1)}万
          </span>
          <span className="text-xs text-foreground-400">
            {comic.chapters.length}话
          </span>
        </div>
      </div>
    </Link>
  );
}